// extracted by mini-css-extract-plugin
export default {"roleSelection":"create_roleSelection__3f7-N"};